import xw from 'xwind';
import styled from '@emotion/styled';

export const Title = styled.h1(
  xw`
    text-3xl
    md:text-4xl text-center 
    text-active mb-5
  `,
);

export const Line = styled.hr(
  xw`
    mx-auto h-0.5 rounded-sm 
    border-0 bg-secondary w-36 mb-7
  `,
);
